import { useRoles } from './useRoles';
import { AccessControlProvider, CanParams } from '@refinedev/core';
import { useMemo } from 'react';

const RESEARCHERS_RESOURCES = ['admin/studies'];

export const useAccessControlProvider = () => {
  const { data: rolesData, isSuccess } = useRoles();

  const provider = useMemo(() => {
    return {
      can: async ({ resource }: CanParams) => {
        if (!isSuccess || !resource) {
          return {
            can: false,
            reason:
              'You are not authorized to access this resource. Failed to fetch user roles.',
          };
        }

        const isAdmin = rolesData?.some((role) => role.name === 'admin');
        const isResearcher = rolesData?.some(
          (role) => role.name === 'researcher',
        );
        const isResearcherResource = RESEARCHERS_RESOURCES.includes(resource);

        if (isAdmin) {
          return {
            can: true,
          };
        }

        if (isResearcherResource && isResearcher) {
          return {
            can: true,
          };
        }

        return {
          can: false,
          reason: 'You are not authorized to access this resource',
        };
      },
    } satisfies AccessControlProvider;
  }, [isSuccess, rolesData]);

  return provider;
};
